export const uk = {
    apply: 'Использовать',
    'continue-edit': 'Продолжить редактирование',
    'creative-to-create': {
        one: 'Будет создан {count} креатив',
        some: 'Будет создано {count} креатива',
        many: 'Будет создано {count} креативов',
        none: 'Будет создано {count} креативов'
    },
    'crop-again': 'Обрезать заново',
    'default-name': 'Новая группа креативов',
    ok: 'ОК',
    'previews-cancel': 'Отменить',
    'previews-save': 'Выбрать размеры и продолжить',
    'previews-title': 'Предварительный просмотр креативов',
    'show-all-previews': 'Показать все'
};
